import React, { useEffect } from 'react';
import { Flex, Typography, theme } from 'antd';

import { KpiSection } from './kpi';
import { PagesSection } from './pages';
import { PerformanceByPathSection } from './performance-by-path';
import SearchPerformanceBusyNotice from './SearchPerformanceBusyNotice';
import SearchPerformanceDataFreshness from './SearchPerformanceDataFreshness';
import SearchPerformanceFilters from './SearchPerformanceFilters';
import SearchPerformanceReconnectAlert from './SearchPerformanceReconnectAlert';
import { createReportedRequests, ReportedRequestsProvider } from './SearchPerformanceReportedRequests';
import useTrackSearchPerformanceEvent from './useTrackSearchPerformanceEvent';

const sessionReportedRequests = createReportedRequests();

function SearchPerformanceDashboard() {
  const { token } = theme.useToken();
  const trackEvent = useTrackSearchPerformanceEvent();

  useEffect(() => {
    trackEvent('Search Performance: Dashboard Viewed');
  }, [trackEvent]);

  return (
    <Flex vertical gap={token.marginLG}>
      <Flex vertical gap={token.marginXS}>
        <Typography.Title level={2} style={{ margin: 0 }}>
          Search Performance
        </Typography.Title>
        <Typography.Text type="secondary" style={{ display: 'block', maxWidth: 640 }}>
          See Prerender&apos;s data with Google Search Performance signals.
        </Typography.Text>
      </Flex>

      {/* TODO: delete once performance is improved */}
      <SearchPerformanceBusyNotice />

      {/* The freshness row is a caveat about the figures the filters scope, so it
          sits tight under them rather than taking a full page-level gap. */}
      <Flex vertical gap={token.marginXS}>
        <SearchPerformanceFilters />
        <SearchPerformanceDataFreshness />
      </Flex>

      <SearchPerformanceReconnectAlert />

      <ReportedRequestsProvider value={sessionReportedRequests}>
        <KpiSection />

        <PerformanceByPathSection />

        <PagesSection />
      </ReportedRequestsProvider>
    </Flex>
  );
}

export default SearchPerformanceDashboard;
